
import {drawer,drawerShow} from '../Menu/drawer-bootstrap'
import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom'
import ReactTooltip from 'react-tooltip'

export default class PlayComponents extends React.PureComponent{
    constructor(props){
        super(props)
        this.state={
            openDrawer:false,
            isOpen: false
        }
        this.openDrawers = this.openDrawers.bind(this)
        this.handleClick = this.handleClick.bind(this)
        // this.applyReactStyle = this.applyReactStyle.bind(this);
    }
    handleClick() {
        this.setState(prevState => ({
          isOpen: !prevState.isOpen
        }))
      }
//     applyReactStyle(data) {
//         // export data in your framework and use its content to apply the style to your popper
//       }
//     componentDidMount(){
//         const reference = document.querySelector('.playsvg');
// const popper = document.querySelector('.my-popper');
// new Popper(reference, popper, {
//   modifiers: {
//     applyStyle: { enabled: false },
//     applyReactStyle: {
//       enabled: true,
//       fn: this.applyReactStyle,
//       order: 900,
//     },
//   },
// });
//     }
    // componentDidUpdate(){
    //     if(this.state.openDrawer){
    //       drawer(
    //         this.props.optionDrawer
    //     )  
    //     drawerShow()
    //     }
        
    // }
    openDrawers(){
        this.setState((state)=>({
            openDrawer:!state.openDrawer
        }))
        if(this.state.openDrawer){
            drawer(
              this.props.optionDrawer
          )  
          drawerShow()
          }
    }
    // componentDidMount(){
    //     console.log(Drawer)
    // }
    
    render(){
        return(
            <>
            <svg className="playsvg" id="i-play"
            onClick={this.openDrawers}
            // data-tip="double click for open"
                data-for="playTool" data-tip="ffffff"
                data-codes="5" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                <path d="M10 2 L10 30 24 16 Z" />
            </svg>
            <ReactTooltip 
            id="playTool"
             effect='solid'
             place="bottom"
            getContent={() => 
                <div>Double click<br/>for open drawer</div> }
//  delayHide={500}
//  delayShow={500}
//  delayUpdate={500}
 border={true}
//  eventOff={this.state.clickables}
//  clickable={this.state.clickables}
 type={'light'}/>
            </>
        )
    }
}

PlayComponents.propTypes = {
    optionDrawer:PropTypes.object.isRequired
};
